import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const programsSearchSchema = z.object({ category: z.string().optional() });

export const Route = createFileRoute("/$lang/programs")({
  component: React.lazy(() =>
    import("@/pages/programs").then((mod) => ({
      default: mod.ProgramsPage,
    })),
  ),
  validateSearch: (search) => programsSearchSchema.parse(search),
});
